import { render } from "./stock-transfer-modal.vue?vue&type=template&id=4ef54cde&scoped=true"
import script from "./stock-transfer-modal.vue?vue&type=script&lang=js"
export * from "./stock-transfer-modal.vue?vue&type=script&lang=js"

import "./stock-transfer-modal.vue?vue&type=style&index=0&id=4ef54cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef54cde"]])

export default __exports__